export const createAttestText = (
  attestName: string | undefined | null,
  attestTime: string | undefined | null
) => {
  if (!attestName || !attestTime) {
    return undefined;
  }
  return `${attestName} (Attesterad: ${new Date(attestTime).toLocaleString(
    'sv-SE',
    {
      timeStyle: 'short',
      dateStyle: 'short',
    }
  )})`;
};
